/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PublishsetUpdateRequest } from '../types/PublishsetUpdate';
import type { PublishsetUpdateResponse } from '../types/PublishsetUpdate';

export type PublishsetsUpdateRequest = PublishsetUpdateRequest;
export type PublishsetsUpdateResponse = PublishsetUpdateResponse;

export type PublishsetsUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this publishset.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PUT /dmx-server/publishsets/{id}/
 *
 * ```yaml
 * operationId: publishsets_update
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetUpdate'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetUpdate'
 *     description: ''
 * ```
 */
export const publishsetsUpdateOperation = ({ id, ...rest }: PublishsetsUpdateQuery) =>
  ({
    method: 'PUT',
    path: `/dmx-server/publishsets/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PUT';
    path: string & { _templateUrl: '/dmx-server/publishsets/{id}/' };
  };

/**
 * PUT /dmx-server/publishsets/{id}/
 *
 * ```yaml
 * operationId: publishsets_update
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetUpdate'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetUpdate'
 *     description: ''
 * ```
 */
export const publishsetsUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: PublishsetsUpdateQuery;
  request: PublishsetUpdateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PublishsetUpdateResponse>> => {
  const operation = publishsetsUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PUT',
    request,
    onUploadProgress,
    cancelToken,
  );
};
